const resources = {
  "en": {
    "forecastAiHelper": {
      "button": "Ask AI Helper",
      "modalTitle": "AI Helper",
      "askButton": "Ask",
      "closeButton": "Close",
      "questionPlaceholder": "Enter your question",
      "loadingLabel": "Generating answer…",
      "credits": {
        "balance": "Credits remaining: {{count}}",
        "balanceWithCap": "{{count}} / {{cap}} credits remaining",
        "balanceUnknown": "Credits balance unavailable",
        "exhausted": "Credits exhausted",
        "lastRefill": "Credits reset on {{date}}"
      },
      "notifications": {
        "loadFailed": "Failed to get AI answer",
        "historyLoadFailed": "Failed to load question history",
        "questionDeleted": "Question deleted",
        "questionDeleteFailed": "Failed to delete question",
        "creditsExhausted": "Credits exhausted. Please wait for the next refill or upgrade your plan.",
        "questionRequired": "Enter a question before asking the AI."
      },
      "helperText": {
        "exhausted": "Need more credits? <0>Manage your subscription.</0>"
      },
      "chat": {
        "typing": "Thinking…",
        "empty": "Ask a question to start the chat.",
        "copyAnswer": "Copy answer",
        "copySuccess": "Answer copied.",
        "copyError": "Unable to copy the answer."
      },
      "quickActions": {
        "savingsPlanLabel": "Savings plan",
        "savingsPlanDisplay": "Savings plan (auto)"
      },
      "layout": {
        "promptTag": "New question",
        "promptTitle": "Ask a question or choose a quick action",
        "promptSubtitle": "Use the box below for your own question, or run a quick action with one click.",
        "chatTag": "Conversation",
        "chatTitle": "AI response",
        "chatSubtitle": "Follow up or ask a new question while you’re here.",
        "historyLink": "Open history"
      }
    }
  },
  "uk": {
    "forecastAiHelper": {
      "button": "Запитати AI-помічника",
      "modalTitle": "AI-помічник",
      "askButton": "Запитати",
      "closeButton": "Закрити",
      "questionPlaceholder": "Введіть своє запитання",
      "loadingLabel": "Формуємо відповідь…",
      "credits": {
        "balance": "Залишилось кредитів: {{count}}",
        "balanceWithCap": "Залишилось кредитів: {{count}} / {{cap}}",
        "balanceUnknown": "Баланс кредитів недоступний",
        "exhausted": "Кредити вичерпано",
        "lastRefill": "Кредити поновляться {{date}}"
      },
      "notifications": {
        "loadFailed": "Не вдалося отримати відповідь AI",
        "historyLoadFailed": "Не вдалося завантажити історію запитань",
        "questionDeleted": "Запитання видалено",
        "questionDeleteFailed": "Не вдалося видалити запитання",
        "creditsExhausted": "Кредити вичерпано. Зачекайте на наступне поповнення або оновіть план.",
        "questionRequired": "Введіть запитання, перш ніж звертатися до AI."
      },
      "helperText": {
        "exhausted": "Потрібно більше кредитів? <0>Керуйте підпискою.</0>"
      },
      "chat": {
        "typing": "Думаю…",
        "empty": "Поставте запитання, щоб почати діалог.",
        "copyAnswer": "Скопіювати відповідь",
        "copySuccess": "Відповідь скопійовано.",
        "copyError": "Не вдалося скопіювати відповідь."
      },
      "quickActions": {
        "savingsPlanLabel": "План заощаджень",
        "savingsPlanDisplay": "План заощаджень (авто)"
      },
      "layout": {
        "promptTag": "Нове запитання",
        "promptTitle": "Поставте запитання або оберіть швидку дію",
        "promptSubtitle": "Використайте поле нижче для свого запитання або запустіть швидку дію в один клік.",
        "chatTag": "Діалог",
        "chatTitle": "Відповідь AI",
        "chatSubtitle": "Ставте уточнення або нове запитання прямо тут.",
        "historyLink": "Відкрити історію"
      }
    }
  }
};

export default resources;
